'use strict';

angular.module('chatEngine.accountSwitcher', [
    'ngRoute',
    'chatEngine.dialog',
    'chatEngine.engines',
    'chatEngine.services',
    'chatEngine.filters',
    'chatEngine.mixpanel'
])

.controller('AccountSwitcherCtrl', ['$scope', '$rootScope', '$window', '$http', 'Dialog', '$modal', '$route',
'$location', '$cacheFactory', '$timeout', 'Engine', 'authService', 'sessionDataService', 'mixpanelService',
    'alertService',
function($scope, $rootScope, $window, $http, Dialog, $modal, $route, $location, $cacheFactory, $timeout,
    Engine, authService, sessionDataService, mixpanelService, alertService) {

    function reset() {
        $scope.otherBots = [];
        $scope.currentBot = null;
        $scope.isLoading = true;
        $scope.loadingError = false;
    }

    reset();

    function sessionSettingsLoaded() {
        reset();

        // Finding the current bot's object
        $scope.currentBot = sessionDataService.getCurrentBotData();

        if ($scope.currentBot.display_pic) {
            $scope.currentBot.display_pic += '?v=' + Date.now();
        }

        $scope.otherBots = sessionDataService.getSessionData().bots.filter(function(b) {
            return b.id !== $scope.currentBot.id;
        }).sort(function(a, b) {
            if(a.id < b.id) {
                return -1;
            } else {
                // No need to handle equality, bots can't have the same ID
                return 1;
            }
        });

        $scope.isLoading = false;
    }

    function sessionSettingsLoadingFailed() {
        $scope.loadingError = true;
        $scope.isLoading = false;
    }

    $scope.switchToBot = function(bot) {
        $rootScope.$broadcast('bot-switch-start');

        $http.patch('/api/v1/session', {bot_username: bot.id})
            .error(switchBotError)
            .success(function() {
                // Very important: remove all cached resources (mostly for the engine pages)
                var $httpDefaultCache = $cacheFactory.get('$http');
                $httpDefaultCache.removeAll();
                Engine.reset();
                sessionDataService.init();
                mixpanelService.init();

                var previousBot = $scope.currentBot;

                // Removing the bot we switch to from other bots
                for(var i = 0 ; i < $scope.otherBots.length ; i++) {
                    if($scope.otherBots[i].id === bot.id) {
                        $scope.otherBots.splice(i, 1);
                        break;
                    }
                }

                // Adding the "previous" current bot
                $scope.otherBots.push($scope.currentBot);

                // Setting it as current
                $scope.currentBot = bot;

                // Disable the global loading
                $rootScope.$broadcast('bot-switch-end');

                if($route.current.$$route.originalPath === '/engine/:id') {
                    // If we are viewing an engine, the ID won't be valid anymore, therefore we need to redirect
                    // to the right one.
                    $location.path('/engine');
                } else {
                    var paramRegex = /:[a-zA-Z0-9]+/gi;
                    if(paramRegex.test($route.current.$$route.originalPath)) {
                        $location.path('/');
                    } else {
                        $route.reload();
                    }
                }

                mixpanelService.track('Switch Bot Success', {
                    'from_bot': previousBot.id,
                    'to_bot': bot.id
                });
            });
    };

    $scope.logout = function() {
        alertService.setShowAppleIdAlert(false);
        authService.clearAuthCookies();
        $window.location.href = '/logout';
    };

    function switchBotError() {
        Dialog.alert(
            'Error',
            'Failed to switch bot, please try again.'
        );

        mixpanelService.track('Switch Bot Error');
    }

    $scope.editContact = function() {
        mixpanelService.forceTrack('Contact Setting Open Modal Click');
        var modal = $modal.open({
            templateUrl: 'views/contact-settings.html',
            controller: 'ContactSettingsCtrl',
            windowClass: 'dialog',
            backdrop: 'static',
            scope: $scope
        });
    };

    // When logging in or accepting the TOS, we need to reset the flow and reload everything
    $scope.$on('sessionDataUpdated', sessionSettingsLoaded);
    $scope.$on('sessionDataFailed', sessionSettingsLoadingFailed);
}]);
